import React from 'react';
import type { GatsbyBrowser } from 'gatsby';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, useTheme } from './src/context/ThemeContext';
import { lightTheme, darkTheme } from './src/theme/themeConfig';
import './src/styles/fonts.css';
import { trackOpenAIPageView } from './src/utils/openaiPixel';

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location, prevLocation }) => {
  // Gatsby invokes this for the initial page and client-side navigation.
  // Hash-only navigation is not another page view.
  if (!prevLocation || location.pathname !== prevLocation.pathname || location.search !== prevLocation.search) {
    trackOpenAIPageView();
  }
};

const ThemeWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { theme } = useTheme();
  const muiTheme = theme === 'light' ? lightTheme : darkTheme;

  return (
    <MuiThemeProvider theme={muiTheme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => (
  <ThemeProvider>
    <ThemeWrapper>{element}</ThemeWrapper>
  </ThemeProvider>
);
